import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { apiFetch } from "../api_call"; 
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  LabelList
} from "recharts";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "./Dashboard.css";

const initialStats = { Overdue: 1, Upcoming: 2, Approved: 1, Compliance: 12 };

const initialDailyTraffic = [
  { date: "Jun 1", users: 4000 },
  { date: "Jun 2", users: 3200 },
  { date: "Jun 3", users: 4500 },
  { date: "Jun 4", users: 2800 },
  { date: "Jun 5", users: 3600 },
  { date: "Jun 6", users: 2400 },
  { date: "Jun 7", users: 3000 },
  { date: "Jun 8", users: 3800 },
  { date: "Jun 9", users: 2000 },
  { date: "Jun 10", users: 4200 },
];

const initialOverdueApproved = initialDailyTraffic.map((d) => ({
  date: d.date,
  Overdue: Math.round(60 + Math.random() * 80),
  Approved: Math.round(200 + Math.random() * 600),
}));




const COLORS = ["#6a20ea", "#f481f0d2", "#d02cec"];

export default function DashboardFY() {
  const [user, setUser] = useState(null);
  const [stats] = useState(initialStats);
  const [complianceTrackData, setComplianceTrackData] = useState([]);
  const [actsStatusData, setActsStatusData] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [showBreakdownModal, setShowBreakdownModal] = useState(false);
const [selectedAct, setSelectedAct] = useState(null);
const [breakdownData, setBreakdownData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [breakdownLoading, setBreakdownLoading] = useState(false);
  const [recentLoading, setRecentLoading] = useState(true);
const [trackLoading, setTrackLoading] = useState(true);
const [calendarLoading, setCalendarLoading] = useState(true);
const [healthLoading, setHealthLoading] = useState(true);
const [alertsLoading, setAlertsLoading] = useState(true);
const [impactLoading, setImpactLoading] = useState(true);
const [actsLoading, setActsLoading] = useState(true);
const [showImpactModal, setShowImpactModal] = useState(false);
const [selectedImpactType, setSelectedImpactType] = useState("");
const [filteredImpactRows, setFilteredImpactRows] = useState([]);
const [showDefenseModal, setShowDefenseModal] = useState(false);
const [dataBreachStatusData, setDataBreachStatusData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [complianceHealthData, setComplianceHealthData] = useState([
  { name: "Compliant", value: 0 },
  { name: "Non-Compliant", value: 0 },
  { name: "At Risk", value: 0 },
]);

const [impactData, setImpactData] = useState([]);
const [impactSummary, setImpactSummary] = useState({ Completed: 0, "In Progress": 0, "Not Started": 0 });
const [impactPercent, setImpactPercent] = useState({ Completed: 0, "In Progress": 0, "Not Started": 0 });


  const [recentCompliances, setRecentCompliances] = useState([]);
  const navigate = useNavigate();

  // Impact Assessment sample data
  // Unified Impact Assessment Colors + Values
const IMPACT_DATA = [
  { name: "Completed", value: 100, color: "#7c3aed" },
  { name: "In Progress", value: 40, color: "#f50bed" },
  { name: "Not Started", value: 60, color: "#d02cec" }
];
const [currentCompliance, setCurrentCompliance] = useState(0);
const [totalCompliances, setTotalCompliances] = useState(0);
const [approvedCompliances, setApprovedCompliances] = useState(0);

const impactBarData = Object.keys(impactSummary).map((key) => ({
  name: key,
  value: impactSummary[key],
  color:
    key === "Completed" ? "#7c3aed" :
    key === "In Progress" ? "#f50bed" :
    "#d02cec"
}));



const impactPieData = Object.keys(impactPercent).map((key) => ({
  name: key,
  value: impactPercent[key],
  fill:
    key === "Completed" ? "#7c3aed" :
    key === "In Progress" ? "#f50bed" :
    "#d02cec"
}));

  const values = impactBarData.map(d => d.value);
const min = Math.min(...values);
const max = Math.max(...values);

// Add padding BELOW the smallest value
const paddedMin = min - 10 < 0 ? 0 : min - 10;  // (so if min = 40 → 30)
const handleLegendClick = (data) => {
  const name = data.value;

  if (name === "At Risk") {
    navigate("/at-risk");
  } else if (name === "Low Risk") {
    navigate("/low-risk");
  } else if (name === "Compliant") {
    navigate("/compliant");
  }
};

// Calculate ticks with padding
const step = Math.ceil((max - paddedMin) / 2) || 1;
const customTicks = [paddedMin, paddedMin + step, max];
const InfoIcon = ({ text }) => (
  <span className="info-icon">
    i
    <span className="tooltip-text">{text}</span>
  </span>
);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

 const parseBackendDate = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split("-");
  return `${year}-${month}-${day}`; // YYYY-MM-DD
};

const fetchImpactAssessment = async (act = null) => {
  try {
    const query = act ? `?act=${encodeURIComponent(act)}` : "";
    const data = await apiFetch(`/dashboard/impact_assessment${query}`);
    if (!data) return;
    setImpactLoading(true);

    // Raw rows
    setImpactData(data.details || []);

    // Summary counts
    setImpactSummary(data.summary || { Completed: 0, "In Progress": 0, "Not Started": 0 });

    // Percentages
    setImpactPercent(data.score_percentage || { Completed: 0, "In Progress": 0, "Not Started": 0 });
  } catch (err) {
    console.error("Failed to fetch impact assessment:", err);
  }finally {
  setImpactLoading(false);
}
};
const BreakdownTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: "8px",
          padding: "10px",
          fontSize: "12px",
        }}
      >
        <strong>{label}</strong>
        <div>Pending: {data.Pending}</div>
        <div>Requested: {data.Requested}</div>
        <div>Approved: {data.Approved}</div>
      </div>
    );
  }

  return null;
};

const handleDataBreachClick = (payload) => {
  if (!payload || !payload.act) return;

  localStorage.setItem("task_name", payload.act); // ✅ save task_name
  navigate("/data_breach_report");                // ✅ redirect
};
const ComplianceTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: "8px",
          padding: "10px",
          fontSize: "12px",
        }}
      >
        <strong>{label}</strong>
        <div>Pending: {data.Pending}</div>
        <div>Requested: {data.Requested}</div>
        <div>Approved: {data.Approved}</div>
      </div>
    );
  }
  return null;
};
const handleImpactClick = (name) => {
  setSelectedImpactType(name);

  const filtered = impactData.filter(
    (row) => row.particular_status === name
  );

  // ✅ Group + Count
  const groupedMap = new Map();

  filtered.forEach((row) => {
    const key = `${row.act}__${row.particular}`;

    if (!groupedMap.has(key)) {
      groupedMap.set(key, {
        ...row,
        count: 1,
      });
    } else {
      groupedMap.get(key).count += 1;
    }
  });

  const groupedRows = Array.from(groupedMap.values());

  setFilteredImpactRows(groupedRows);
  setShowImpactModal(true);
};
const handleTrackClick = (dataKey) => {
  if (dataKey === "Overdue") {
    navigate("/overdue");
  } else if (dataKey === "Approved") {
    navigate("/approved");
  }
};
const handleTrackLegendClick = (data) => {
  const key = data.dataKey;

  if (key === "Overdue") {
    navigate("/overdue");
  } else if (key === "Approved") {
    navigate("/approved");
  }
};

const [searchitem, setSearchItem] = useState("");
const fetchDashboardData = async () => {
  try {
    const data = await apiFetch("/dashboard/admin");
    if (!data) return;
    setTrackLoading(false);
    setRecentLoading(false);
    setHealthLoading(false);
    setActsLoading(false);

    setCurrentCompliance(Number(data.compliance_score_percent) || 0);
    setTotalCompliances(Number(data.total_compliances) || 0);
    setApprovedCompliances(Number(data.approved_compliances) || 0);

    /* ✅ COMPLIANCE TRACK MAPPING */
    if (Array.isArray(data.quarterly_compliance_track)) {
      const formattedTrack = data.quarterly_compliance_track.map((q) => ({
        quarter: q.quarter_label,                 // X-axis
        Approved: Number(q.approved_count) || 0,  // Line 1
        Overdue: Number(q.overdue_count) || 0,    // Line 2
      }));

      setComplianceTrackData(formattedTrack);
    }
    /* Acts Status Summary (NEW GRAPH) */
if (Array.isArray(data.acts_status_summary)) {
  const formattedActs = data.acts_status_summary.map((a) => {
    const Pending = Number(a.pending_count) || 0;
    const Requested = Number(a.requested_count) || 0;
    const Approved = Number(a.completed_count) || 0;

    const total = Pending + Requested + Approved;

    return {
      act: a.act_name,
      Pending,
      Requested,
      Approved,

      pendingPercent: total ? Math.round((Pending / total) * 100) : 0,
      requestedPercent: total ? Math.round((Requested / total) * 100) : 0,
      approvedPercent: total ? Math.round((Approved / total) * 100) : 0,
    };
  });

  setActsStatusData(formattedActs);
}
/* Data Breach Summary (NEW GRAPH) */
if (Array.isArray(data.data_breach_summary)) {
  const formattedDB = data.data_breach_summary.map((a) => {
    const Pending = Number(a.pending_count) || 0;
    const Requested = Number(a.requested_count) || 0;
    const Approved = Number(a.completed_count) || 0;

    const total = Pending + Requested + Approved;

    return {
      act: a.task_name,   // 👈 same structure as acts

      Pending,
      Requested,
      Approved,

      pendingPercent: total ? Math.round((Pending / total) * 100) : 0,
      requestedPercent: total ? Math.round((Requested / total) * 100) : 0,
      approvedPercent: total ? Math.round((Approved / total) * 100) : 0,
    };
  });

  setDataBreachStatusData(formattedDB);
}


    /* Recent compliances */
    const recent = Array.isArray(data.recent_compliances)
      ? data.recent_compliances
      : [];

    setRecentCompliances(
      recent.map((item) => ({
        id: item.id,
        title: item.title,
        start_date: item.start_date,
        end_date: item.end_date,
        type: item.type,
      }))
    );

    /* Compliance health */
   setComplianceHealthData([
  { name: "Compliant", value: Number(data.no_risk_percent) || 0 },
  { name: "Low Risk", value: Number(data.low_risk_percent) || 0 },
  { name: "At Risk", value: Number(data.at_risk_percent) || 0 },
]);

    } catch (err) {
    console.error("Dashboard admin API failed:", err);
  } finally {
    setTrackLoading(false);
    setRecentLoading(false);
    setHealthLoading(false);
    setActsLoading(false);
  }
};

const fetchStatusBreakdown = async (act) => {
  try {
    setBreakdownLoading(true);

    const data = await apiFetch("/dashboard/status-breakdown", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ act_name: act }),
    });

    if (!data || !Array.isArray(data.status_breakdown)) {
      setBreakdownData([]);
      return;
    }

    const formatted = data.status_breakdown.map((p) => {
      const Pending = Number(p.pending_count) || 0;
      const Requested = Number(p.requested_count) || 0;
      const Approved = Number(p.approved_count) || 0;

      const total = Pending + Requested + Approved;

      return {
        particular: p.regcmp_particular,
        complianceId: p.regcmp_compliance_id,

        Pending,
        Requested,
        Approved,

        pendingPercent: total ? Math.round((Pending / total) * 100) : 0,
        requestedPercent: total ? Math.round((Requested / total) * 100) : 0,
        approvedPercent: total ? Math.round((Approved / total) * 100) : 0,
      };
    });

    setBreakdownData(formatted);
  } catch (err) {
    console.error("Failed to fetch breakdown:", err);
  } finally {
    setBreakdownLoading(false);
  }
};



const fetchEvents = async () => {
  setCalendarLoading(true);
  try {
    const data = await apiFetch("/calender/admin/calendar");

    if (data && Array.isArray(data.events)) {
      const mappedTasks = data.events.map((e) => ({
        id: e.id,
        cal_date: parseBackendDate(e.date),
        cal_event: e.title,
        status: e.status,
        type: e.type,
      }));

      setTasks(mappedTasks);

      setEvents(
  mappedTasks.map((t) => ({
    id: t.id,
    title: t.cal_event,
    start: t.cal_date,
    extendedProps: {
      status: t.status,
      type: t.type,
    },
  }))
);

    }
  } catch (err) {
    console.error("Error fetching events:", err);
 } finally {
  setCalendarLoading(false);
}
};





 

 useEffect(() => {
  fetchEvents();
  fetchDashboardData(); // load compliance stats & recent compliances
  fetchImpactAssessment();
}, []);

// Inside Dashboard.jsx
const [alerts, setAlerts] = useState([]);

const fetchAlerts = async () => {
  try {
    const data = await apiFetch("/alerts/overdue"); // call your Flask API
    if (!data || !Array.isArray(data.alerts)) return;
    setAlertsLoading(true);

    setAlerts(
      data.alerts.map((alert) => {
        let risk = alert.days_overdue >= 10 ? "❗ High Risk" : "⚠️ Moderate Risk";
        return {
          ...alert,
          riskText: `${alert.title} (${alert.act}) is at ${risk}`,
        };
      })
    );
  } catch (err) {
    console.error("Error fetching alerts:", err);
    setAlerts([]);
  }finally {
  setAlertsLoading(false);
}
};

// Call it on component mount
useEffect(() => {
  fetchAlerts();
}, []);


 


  const handleDateClick = (info) => {
  const date = info.date;
  const formattedDate = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  setSelectedDate(formattedDate);
  setShowModal(true);
};
const handleActClick = async (payload) => {
  if (!payload || !payload.act) return;

  setSelectedAct(payload.act);
  setShowBreakdownModal(true);

  await fetchStatusBreakdown(payload.act);
};

  const tasksForDate = tasks.filter((t) => t.cal_date === selectedDate);
  const defenseData = [
  {
    name: "Compliant",
    value: approvedCompliances,
  },
  {
    name: "Non-Compliant",
    value: totalCompliances - approvedCompliances,
  },
];
const handleDefenseClick = (data) => {
  if (data.name === "Compliant") {
    navigate("/compliant-");
  } else {
    navigate("/non_compliant");
  }
};

  // ---- Dynamic sizing for the Data Breach Summary card ----
  // The chart itself already sizes to the data (rows * 48, min 300).
  // The card container was left at its default/CSS height, so once the
  // chart grew past that, it overflowed instead of the card growing with
  // it. We compute the same height here and apply it to the card wrapper
  // (chart height + room for the heading/"View More" row) so the card
  // always expands to fit its content.
  const DB_ROW_HEIGHT = 48;
  const DB_MIN_CHART_HEIGHT = 300;
  const DB_CARD_CHROME = 90; // space for heading + "View More" row + padding
  const dataBreachChartHeight =
    dataBreachStatusData.length > 0
      ? Math.max(DB_MIN_CHART_HEIGHT, dataBreachStatusData.length * DB_ROW_HEIGHT)
      : DB_MIN_CHART_HEIGHT;
  const dataBreachCardHeight = dataBreachChartHeight + DB_CARD_CHROME;

  return (
    <div className="Dashboard">
      <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      {/* HEADER SECTION */}
      <div className="headSection" style={{marginTop:'8px'}}>
        <div className="rightGroup">
          <div className="buttonGroup">
            <button className="headBtn" onClick={() => (window.location.href = "/user_dashboard")}>
              + Compliance Zone
            </button>
            <button className="headBtn" onClick={() => navigate("/coming-soon")}>
              + ESG
            </button>
            <button className="headBtn" onClick={() => (window.location.href = "/coming-soon")}>
              + DPDP Act
            </button>
            <button className="headBtn" onClick={() => (window.location.href = "/coming-soon")}>
              + Bharat Vault
            </button>
          </div>

         <div className="searchBox">
  <input
    type="text"
    placeholder="Can't find something? Search it here!"
    value={searchitem}
    onChange={(e) => setSearchItem(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        // Save the current input and navigate
        // Optional: you can also save in localStorage if needed
        localStorage.setItem("searchitem", searchitem); 
        navigate("/comprehensive");
      }
    }}
  />
  <FaSearch
    className="searchIcon"
    onClick={() => {
      localStorage.setItem("searchitem", searchitem);
      navigate("/comprehensive");
    }}
  />
</div>
        </div>
      </div>

      {/* WELCOME */}
      <div className="welcome-bar">
        <div className="welcome-user">
          Hello,
          <br />
          {user ? user.usrlst_name : "Admin"}
        </div>
     <div
  className="welcome-score"
  style={{ cursor: "pointer" }}
  onClick={() => setShowDefenseModal(true)}
>
  Defensive Strength: {currentCompliance.toFixed(2)}%
</div>

      </div>

      {/* ====== CHARTS SECTION (3 rows as requested) ====== */}
      <section className="charts">
        {/* ROW 1: Recent Compliance | Compliance Track | Calendar */}
        <div className="chart-row row-1">
          <div className="chart-card">
            <h3 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  Recent Compliance
  <InfoIcon text="Recently added instances are displayed here" />
</h3>
            <table className="compliance-table">
              <thead>
                <tr>
                  <th>Comp_id</th>
                  <th>Compliance</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
{recentLoading ? (
  <tr>
    <td colSpan="4" style={{ textAlign: "center" }}>
      Loading...
    </td>
  </tr>
) : recentCompliances.length > 0 ? (
  recentCompliances.map((row) => (
    <tr key={row.id}>
      <td>{row.id}</td>
      <td>{row.title}</td>
      <td>{row.start_date}</td>
      <td>{row.end_date}</td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan="4" style={{ textAlign: "center" }}>
      No recent compliance
    </td>
  </tr>
)}
</tbody>


            </table>
            <div className="view-more" onClick={() => navigate("/comprehensive")}>
              View More
            </div>
          </div>

          <div className="chart-card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <h3 style={{ display: "flex", alignItems: "center", gap: "10px", margin: 0 }}>
                Compliance Track
                <InfoIcon text="Approved and Overdue Instances for each quarter" />
              </h3>
              <span
                style={{
                  fontSize: "10px",
                  fontWeight: 600,
                  color: "#6a20ea",
                  background: "#f3ecff",
                  padding: "2px 8px",
                  borderRadius: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                Current Financial Year Only
              </span>
            </div>
            {trackLoading ? (
  <div className="loading-box">Loading...</div>
) : complianceTrackData.length > 0 ? (
 <ResponsiveContainer width="100%" height={240}>
  <LineChart data={complianceTrackData}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="quarter" />
    <YAxis />
    <Tooltip />

    <Legend
      onClick={handleTrackLegendClick}
      wrapperStyle={{ cursor: "pointer" }}
    />

    <Line
  type="monotone"
  dataKey="Overdue"
  stroke="#cc0e0e"
  strokeWidth={2}
  cursor="pointer"
  onClick={() => handleTrackClick("Overdue")}
/>

<Line
  type="monotone"
  dataKey="Approved"
  stroke="#38269f"
  strokeWidth={2}
  cursor="pointer"
  onClick={() => handleTrackClick("Approved")}
/>
  </LineChart>
</ResponsiveContainer>
) : (
  <div style={{ height: 240, display: "flex", alignItems: "center", justifyContent: "center", color: "#555" }}>
    No Compliance found
  </div>
)}

          </div>

          <div className="chart-card calendar-card">
            <h3 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
 Compliance Calender
  <InfoIcon text="Date wise Action dates for each instance" />
</h3>
            <div className="calendar-wrapper">
              {calendarLoading && <div className="loading">Loading...</div>}

             <FullCalendar
  plugins={[dayGridPlugin, interactionPlugin]}
  initialView="dayGridMonth"
  events={events}
  dateClick={handleDateClick} 
  headerToolbar={{ left: "title", center: "", right: "prev,next" }}
  height="70%"
  dayCellContent={(arg) => {
    const date = arg.date;
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;

    const dayTasks = tasks.filter((t) => t.cal_date === dateStr);

    let innerHtml = "";

    if (dayTasks.length >= 1) {
      // Multiple tasks → show a single dot on the right of date
      innerHtml = `
        <div style="display:flex; align-items:center; justify-content:flex-start; gap:4px;">
          <div class="fc-daygrid-day-number">${arg.dayNumberText}</div>
          <div class="task-dot"></div>
        </div>
      `;
    } else if (dayTasks.length === 1) {
      const t = dayTasks[0];
      const displayText =
        t.cal_event.length > 15 ? t.cal_event.slice(0, 15) + "..." : t.cal_event;

      innerHtml = `
        <div style="display:flex; align-items:center; justify-content:flex-start; gap:4px;">
          <div class="fc-daygrid-day-number">${arg.dayNumberText}</div>
          <div class="task-text" title="${t.cal_event}">${displayText}</div>
        </div>
      `;
    } else {
      innerHtml = `<div class="fc-daygrid-day-number">${arg.dayNumberText}</div>`;
    }

    // Fixed-height wrapper to prevent jumping
    return {
      html: `<div style="height:27px;">${innerHtml}</div>`
    };
  }}
/>


            </div>
          </div>
        </div>

        {/* ROW 2: Compliance Health | Alerts & Notifications | Impact Assessment */}
        <div className="chart-row row-2">
       <div className="chart-card">
 <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  Compliance Health

  <span className="info-icon">
    i
    <span className="tooltip-text">
      <strong>At Risk Compliances:</strong> Compliances that have not been approved and are past their action dates<br />
      <strong>Low Risk Compliances:</strong> Compliances that are either pending for review or are completed past their action dates<br />
      <strong>Compliant:</strong> Compliances that have been approved before their action date
    </span>
  </span>
</h3>

  {healthLoading ? (
    <div className="loading-box">Loading...</div>
  ) : complianceHealthData.reduce((sum, d) => sum + d.value, 0) > 0 ? (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
       <Pie
  data={complianceHealthData}
  dataKey="value"
  nameKey="name"
  cx="50%"
  cy="50%"
  innerRadius={30}
  outerRadius={70}
  label={({ percent }) => `(${(percent * 100).toFixed(0)}%)`}
  cursor="pointer"
  onClick={(data) => handleLegendClick({ value: data.name })}
>
  {complianceHealthData.map((entry, index) => (
    <Cell key={index} fill={COLORS[index % COLORS.length]} />
  ))}
</Pie>

        <Tooltip
          formatter={(value, name) => {
            const total = complianceHealthData.reduce(
              (sum, entry) => sum + entry.value,
              0
            );
            const percent = total ? ((value / total) * 100).toFixed(0) : 0;
            return [`${percent}%`, name];
          }}
        />

        <Legend
          layout="vertical"
          verticalAlign="middle"
          align="right"
          onClick={handleLegendClick}
          wrapperStyle={{ cursor: "pointer" }}
        />
      </PieChart>
    </ResponsiveContainer>
  ) : (
    <div
      style={{
        height: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#555",
      }}
    >
      No Compliance found
    </div>
  )}
</div>

         <div className="chart-card">
  <h3>Alerts & Notifications</h3>

  {alertsLoading ? (
  <div className="loading-box">Loading...</div>
) : alerts.length > 0 ? (
    <ul className="alerts-list">
      {alerts.map((a) => (
        <li
          key={a.id}
          className={`alert-item ${a.days_overdue >= 10 ? "overdue" : "expiring"}`}
        >
          {a.riskText}
        </li>
      ))}
    </ul>
  ) : (
    <div
      style={{
        height: 150,              // adjust height to fit your card
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#555",
        fontWeight: "500",
        fontSize: "16px",
      }}
    >
      No alerts found
    </div>
  )}
</div>



         {/* IMPACT ASSESSMENT (replace existing Impact Assessment card) */}
<div className="chart-card impact-card">
  <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  Impact Assessment

  <span className="info-icon">
    i
    <span className="tooltip-text">
      <strong>Completed:</strong> Compliances with all instances being approved<br />
      <strong>In Progress:</strong> Compliances with some instances being approved<br />
      <strong>Not Started:</strong> Compliances with all instances being pending
    </span>
  </span>
</h3>

  {impactLoading ? (
  <div className="loading-box">Loading...</div>
) : impactBarData.every(d => d.value === 0) &&
  impactPieData.every(d => d.value === 0) ? (
    <div
      style={{
        height: 200,             // adjust height to match card
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#555",
        fontWeight: "500",
        fontSize: "16px",
      }}
    >
      No Compliance found
    </div>
  ) : (
    <div className="impact-body">

      {/* LEFT BAR GRAPH */}
      <div className="impact-left">
        <div className="subheader dark">Overall Count</div>
        <ResponsiveContainer width="100%" height={180}>
          <BarChart
            data={impactBarData}
            layout="vertical"
            margin={{ top: 10, right: 20, left: 20, bottom: 0 }}
          >
            <XAxis
              type="number"
              domain={[0, Math.max(...impactBarData.map(d => d.value), 10)]}
              stroke="#333"
              tick={{ fill: "#000" }}
              axisLine={true}
            />
            <YAxis
              type="category"
              dataKey="name"
              tick={{ fontSize: 11, fill: "#000" }}
              width={100}
              axisLine={true}
              tickLine={true}
              stroke="#333"
            />
            <Tooltip />
           <Bar
  dataKey="value"
  barSize={18}
  radius={[5, 5, 5, 5]}
  onClick={(data) => handleImpactClick(data.name)}
  style={{ cursor: "pointer" }}
>
  {impactBarData.map((entry, index) => (
    <Cell key={index} fill={entry.color} />
  ))}
</Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* RIGHT PIE CHART */}
      <div className="impact-right">
        <div className="subheader dark">Percentage (%)</div>
        <div className="pie-wrapper">
          <ResponsiveContainer width="100%" height={180}>
            <PieChart>
            <Pie
  data={impactPieData}
  dataKey="value"
  nameKey="name"
  outerRadius={70}
  label={({ percent }) => `${Math.round(percent * 100)}%`}
  onClick={(data) => handleImpactClick(data.name)}
  style={{ cursor: "pointer" }}
>
  {impactPieData.map((entry, i) => (
    <Cell key={i} fill={entry.fill} />
  ))}
</Pie>
              <Tooltip
                formatter={(value, name) => {
                  const total = impactPieData.reduce((sum, entry) => sum + entry.value, 0);
                  const percent = total ? ((value / total) * 100).toFixed(2) : 0;
                  return [`${percent}%`, name];
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

    </div>
  )}
</div>


        </div>
        {/* ROW 3: Acts Status Overview (FULL WIDTH) */}
{/* ROW 3: Acts Status Overview (FULL WIDTH - DYNAMIC HEIGHT) */}
<div className="chart-row row-full">
  <div className="chart-card full-width">
    <h3 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
 Compliance Status
  <InfoIcon text="Approved, Pending and Requested Instances for each Statutory Compliance and Data Compliance" />
</h3>

    {actsLoading ? (
  <div className="no-data-box">Loading...</div>
) : actsStatusData.length > 0 ? (
      <ResponsiveContainer
        width="100%"
        height={Math.max(300, actsStatusData.length * 48)}
      >
        <BarChart
  data={actsStatusData}
  layout="vertical"
  margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
  barCategoryGap="0%"
>
          <CartesianGrid strokeDasharray="2 2" stroke="#eee" />

          <XAxis
            type="number"
            domain={[0, 100]}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11 }}
          />

          <YAxis
            type="category"
            dataKey="act"
            width={170}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
          />

          <Tooltip
            cursor={{ fill: "rgba(0,0,0,0.05)" }}
            content={<ComplianceTooltip />}
          />

          <Legend
            verticalAlign="top"
            height={25}
            wrapperStyle={{ fontSize: "12px" }}
          />

          {/* Pending */}
          {/* Pending */}
<Bar
  dataKey="pendingPercent"
  name="Pending"
  stackId="a"
  fill="#d02cec"
  barSize={22}
  radius={[6,0,0,6]}
  cursor="pointer"
  onClick={(data) => handleActClick(data.payload)}
>
  <LabelList
    dataKey="pendingPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

{/* Requested */}
<Bar
  dataKey="requestedPercent"
  name="Requested"
  stackId="a"
  fill="#f481f0d2"
  barSize={22}
  cursor="pointer"
  onClick={(data) => handleActClick(data.payload)}
>
  <LabelList
    dataKey="requestedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

{/* Approved */}
<Bar
  dataKey="approvedPercent"
  name="Approved"
  stackId="a"
  fill="#6a20ea"
  barSize={22}
  radius={[0,6,6,0]}
  cursor="pointer"
  onClick={(data) => handleActClick(data.payload)}
>
  <LabelList
    dataKey="approvedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

        </BarChart>
      </ResponsiveContainer>
    ) : (
      <div className="no-data-box">
        No Compliance Data Found
      </div>
    )}
  </div>
</div>
{/* DATA BREACH SUMMARY (NEW) */}
<div className="chart-row row-full">
  <div
    className="chart-card full-width"
    style={{
      // Card now grows with its content instead of staying fixed while
      // the chart inside it grows — this is what was causing the overflow.
      height: dataBreachCardHeight,
      minHeight: dataBreachCardHeight,
      overflow: "visible",
      transition: "height 0.25s ease",
    }}
  >
   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <h3 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  Data Breach Summary
  <InfoIcon text="Requested,Pending and Approved tasks for Data Breaches" />
</h3>

  <div
    className="view-more"
    style={{
      fontSize: "12px",
      padding: "4px 10px",
      borderRadius: "6px",
      cursor: "pointer",
      whiteSpace: "nowrap"
    }}
    onClick={() => navigate("/data_breach_report")}
  >
    View More
  </div>
</div>

    {actsLoading ? (
      <div className="no-data-box">Loading...</div>
    ) : dataBreachStatusData.length > 0 ? (
      // Wrapper div gets an explicit, data-driven height so the chart can
      // never clip rows as more breaches are added. This matches the height
      // now applied to the card itself above, so the chart always fits.
      <div
        style={{
          width: "100%",
          height: dataBreachChartHeight,
          overflow: "visible",
        }}
      >
      <ResponsiveContainer
        width="100%"
        height={dataBreachChartHeight}
      >
        <BarChart
          data={dataBreachStatusData}
          layout="vertical"
          margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
          barCategoryGap="0%"
        >
          <CartesianGrid strokeDasharray="2 2" stroke="#eee" />

          <XAxis
            type="number"
            domain={[0, 100]}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11 }}
          />

          <YAxis
            type="category"
            dataKey="act"
            width={170}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
          />

          <Tooltip content={<ComplianceTooltip />} />

          <Legend
            verticalAlign="top"
            height={25}
            wrapperStyle={{ fontSize: "12px" }}
          />

          {/* Pending */}
         {/* Pending */}
<Bar
  dataKey="pendingPercent"
  name="Pending"
  stackId="a"
  fill="#d02cec"
  barSize={22}
  radius={[6, 0, 0, 6]}
  cursor="pointer"
  onClick={(data) => handleDataBreachClick(data.payload)}
>
  <LabelList
    dataKey="pendingPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

{/* Requested */}
<Bar
  dataKey="requestedPercent"
  name="Requested"
  stackId="a"
  fill="#f481f0d2"
  barSize={22}
  cursor="pointer"
  onClick={(data) => handleDataBreachClick(data.payload)}
>
  <LabelList
    dataKey="requestedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

{/* Approved */}
<Bar
  dataKey="approvedPercent"
  name="Approved"
  stackId="a"
  fill="#6a20ea"
  barSize={22}
  radius={[0, 6, 6, 0]}
  cursor="pointer"
  onClick={(data) => handleDataBreachClick(data.payload)}
>
  <LabelList
    dataKey="approvedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>
        </BarChart>
      </ResponsiveContainer>
      </div>
    ) : (
      <div className="no-data-box">
        No Data Breach Data Found
      </div>
    )}
  </div>
</div>

        {/* ROW 3: Risk Heatmap | Tasks & Workflow 
        <div className="chart-row row-3">
          <div className="chart-card">
            <h3>Risk Heatmap</h3>
            <table className="heatmap-table">
              <thead>
                <tr>
                  <th>Department</th>
                  <th>High</th>
                  <th>Medium</th>
                  <th>Low</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Finance</td>
                  <td className="red"></td>
                  <td className="yellow"></td>
                  <td className="green"></td>
                </tr>
                <tr>
                  <td>IT</td>
                  <td className="yellow"></td>
                  <td className="red"></td>
                  <td className="green"></td>
                </tr>
                <tr>
                  <td>HR</td>
                  <td className="yellow"></td>
                  <td className="yellow"></td>
                  <td className="green"></td>
                </tr>
                <tr>
                  <td>Operations</td>
                  <td className="red"></td>
                  <td className="yellow"></td>
                  <td className="green"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="chart-card">
            <div className="tasks-header">
              <h3>Tasks & Workflow</h3>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: "60%" }}></div>
              </div>
              <span className="progress-text">60%</span>
            </div>

            <table className="tasks-table">
              <thead>
                <tr>
                  <th>Task</th>
                  <th>Departmental User</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((t) => (
                  <tr key={t.id}>
                    <td>{t.cal_event}</td>
                    <td>{user ? user.usrlst_name : "Admin"}</td>
                    <td>{t.cal_date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>*/}
      </section>

      {showBreakdownModal && (
  <div
    className="ct-modal-backdrop"
    onClick={() => setShowBreakdownModal(false)}
  >
    <div
      className="ct-modal"
      style={{ width: "800px", maxHeight: "500px" }}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ textAlign: "center" }}>
        {selectedAct} - Compliance Breakdown
      </h3>

      {breakdownLoading ? (
  <div style={{ textAlign: "center", padding: "40px" }}>
    Loading breakdown...
  </div>
) : breakdownData.length > 0 ? (
        <ResponsiveContainer
          width="100%"
          height={Math.max(250, breakdownData.length * 45)}
        >
          <BarChart
  data={breakdownData}
  layout="vertical"
  margin={{ top: 10, right: 20, left: 10, bottom: 10 }}
>
  <CartesianGrid strokeDasharray="2 2" />

  <XAxis type="number" domain={[0, 100]} />

  <YAxis
    type="category"
    dataKey="particular"
    width={250}
    tick={{ fontSize: 12 }}
  />

  <Tooltip content={<BreakdownTooltip />} />
  <Legend />

  {/* Pending */}
  <Bar
  dataKey="pendingPercent"
  name="Pending"
  stackId="a"
  fill="#d02cec"
  barSize={20}
  cursor="pointer"
  onClick={(data) => {
    const item = data.payload;
    localStorage.setItem("complianceId", item.complianceId);
    navigate("/comprehensive");
  }}
>
  <LabelList
    dataKey="pendingPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

  {/* Requested */}
  <Bar
  dataKey="requestedPercent"
  name="Requested"
  stackId="a"
  fill="#f481f0d2"
  barSize={20}
  cursor="pointer"
  onClick={(data) => {
    const item = data.payload;
    localStorage.setItem("complianceId", item.complianceId);
    navigate("/comprehensive");
  }}
>
  <LabelList
    dataKey="requestedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#000"
    fontSize={11}
    fontWeight="600"
  />
</Bar>

  {/* Approved */}
  <Bar
  dataKey="approvedPercent"
  name="Approved"
  stackId="a"
  fill="#6a20ea"
  barSize={20}
  cursor="pointer"
  onClick={(data) => {
    const item = data.payload;
    localStorage.setItem("complianceId", item.complianceId);
    navigate("/comprehensive");
  }}
>
  <LabelList
    dataKey="approvedPercent"
    position="center"
    formatter={(v) => (v > 0 ? `${v}%` : "")}
    fill="#fff"
    fontSize={11}
    fontWeight="600"
  />
</Bar>
</BarChart>
        </ResponsiveContainer>
      ) : (
        <div style={{ textAlign: "center", padding: "40px" }}>
          No Data Found
        </div>
      )}
    </div>
  </div>
)}


{showImpactModal && (
  <div
    className="ct-modal-backdrop"
    onClick={() => setShowImpactModal(false)}
  >
    <div
      className="ct-modal"
      style={{ width: "900px", maxHeight: "500px", overflowY: "auto" }}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ textAlign: "center" }}>
        {selectedImpactType} Compliances
      </h3>

      {filteredImpactRows.length > 0 ? (
        <table className="compliance-table">
          <thead>
            <tr>
              <th>Act</th>
              <th>Particular</th>
              <th>Instances</th>
            </tr>
          </thead>
          <tbody>
  {filteredImpactRows.map((row, index) => (
    <tr
      key={index}
      style={{ cursor: "pointer" }}
      onClick={() => {
        localStorage.setItem("complianceId", row.compliance_id);
        navigate("/comprehensive");
      }}
    >
      <td>{row.act}</td>
      <td>{row.particular}</td>
      <td>
        {row.count} instances
      </td>
    </tr>
  ))}
</tbody>
        </table>
      ) : (
        <div style={{ textAlign: "center", padding: "40px" }}>
          No Data Found
        </div>
      )}
    </div>
  </div>
)}

{showDefenseModal && (
  <div
    className="ct-modal-backdrop"
    onClick={() => setShowDefenseModal(false)}
  >
    <div
      className="ct-modal"
      style={{ width: "500px", height: "350px" }}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ textAlign: "center" }}>
        Compliance Defense Breakdown
      </h3>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={defenseData}>
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="name" />
          <YAxis
  domain={[0, (dataMax) => dataMax + 10]}
/>

          <Tooltip />
          

          <Bar
            dataKey="value"
            barSize={40}
            radius={[6, 6, 0, 0]}
            cursor="pointer"
            onClick={(data) => handleDefenseClick(data)}
          ><LabelList dataKey="value" position="top" />
            {defenseData.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  entry.name === "Compliant"
                    ? "#6a20ea"
                    : "#cc0e0e"
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
)}

      {/* TASK MODAL */}
      {showModal && (
  <div className="ct-modal-backdrop" onClick={() => setShowModal(false)}>
    <div
      className="ct-modal"
      onClick={(e) => e.stopPropagation()}
      style={{ maxHeight: "400px", overflowY: "auto" }}
    >
      <h3 style={{ textAlign: "center" }}>
        Tasks for {selectedDate}
      </h3>

      {tasksForDate.length > 0 ? (
        <ul className="task-list">
          {tasksForDate.map((t) => (
            <li
              key={t.id}
              className="task-item"
              style={{
                padding: "8px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <strong>{t.cal_event}</strong>
              <div style={{ fontSize: "12px", color: "#666" }}>
                Type: {t.type} | Status: {t.status}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="no-tasks">No tasks for this date</p>
      )}
    </div>
  </div>
)}

    </div>
  );
}